import React from 'react';
import { Link } from 'react-router-dom';
import './step.css';

const Step = () => {
  return (
    <div className='step-main-container'>
      <h1 className='step-title'>Steps to Follow for Online Admission</h1>
      <div className='step-list'>
        <p><strong>Step 1:</strong> Visit the official admission form page.</p>
        <p><strong>Step 2:</strong> Fill out your personal and academic details accurately.</p>
        <p><strong>Step 3:</strong> Upload all required documents in the specified format.</p>
        <p><strong>Step 4:</strong> Make the payment and upload the transaction screenshot.</p>
        <p><strong>Step 5:</strong> Submit the form and wait for confirmation via email or SMS.</p>
      </div>

      <div className="step-buttons">
        <Link to='/AdmissionForm' className='step-btn'>Go to Admission Form</Link>
        <Link to='/Account' className='step-btn'>View Account Details</Link>
      </div>
    </div>
  );
};

export default Step;
